<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <template v-if="cartsupp && cartsupp.items">
        <div class="bg-light">
          <div class="container section-header-breadcrumb">
            <div class="row">
              <div class="content text-left col-12">
                <h2 class="title-page">
                  <span class="back-link cursor-pointer" @click="BackToLivraison">
                    <i class="ti ti-back-left font-20 orange-color pe-2"></i>
                  </span>
                  Mode de livraison
                </h2>
                <label class="breadcrumb-text">
                   <span class="pointer-cursor" @click.prevent="GoToDashboard" >Accueil</span> > <span class="pointer-cursor" @click.prevent="GoToStepCart" >Mon panier</span>  > <span class="cursor-pointer" @click="BackToLivraison"> Livraison > </span>
                  <span>Livraison en point relais</span>
                </label>
              </div>
            </div>
          </div>
          <div class="livraison-page container">
            <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
              <div class="col-12 col-lg-8 block-adresses">
                <!-- Même approche que les autres composants - cacher step-cart-centent sur mobile -->
                <div class="row step-cart ps-3 pe-3">
                  <div class="col-12">
                    <div class="d-flex gap-2 align-items-center py-3 step-cart-centent flex-wrap">
                      <div class="step-number" @click.prevent="GoToStepCart">
                        <span class="badge mx-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-100 h-75"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#ec621a"
                            stroke-width="3"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        </span>
                        <span class="step-title">Votre panier</span>
                      </div>
                      <div class="separator"></div>
                      <div class="step-number">
                        <span class="badge badge-blue mx-2">2</span>
                        <span class="step-title">Livraison</span>
                      </div>
                      <div class="separator"></div>
                      <div class="step-number">
                        <span class="badge mx-2">3</span>
                        <span class="step-title">Paiement</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-white round-10 p-3 p-md-5">
                  <div class="d-flex justify-content-between">
                    <p class="font-18 font-bold blue-color text-start">
                      Pour élargir votre recherche, indiquez un nouveau code postal
                    </p>
                  </div>
                  <div class="text-start mt-3">
                    <span>Pour une recherche précise des points relais, veuillez saisir <strong>le code postal et la ville</strong>.</span>
                  </div>

                  <div class="d-flex flex-column gap-3 py-4">
                    <div class="search-group d-flex flex-column flex-md-row gap-3">
                      <!-- Postal Code -->
                      <div class="flex-fill">
                        <div class="form-input">
                          <label class="label-control">Code postal</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Ex: 75000"
                            v-model="zipCode"
                            v-only-digits
                            pattern="\d{5}"
                            maxlength="5"
                          />
                        </div>
                      </div>

                      <!-- City -->
                      <div class="flex-fill">
                        <div class="form-input">
                          <label class="label-control">Ville</label>
                          <input type="text" class="form-control" placeholder="Ex: Paris" v-model="city" />
                        </div>
                      </div>

                      <!-- Address -->
                      <div class="flex-fill">
                        <div class="form-input">
                          <label class="label-control">Adresse</label>
                          <input type="text" class="form-control" placeholder="Ex: Rue de Rivoli" v-model="address" />
                        </div>
                      </div>
                    </div>

                    <!-- Search Button -->
                    <div class="d-flex justify-content-center justify-content-md-end">
                      <button class="btn btn-orange w-100 w-md-auto" :disabled="loading" @click="searchPickupPoints">
                        <i class="ti ti-search me-2"></i>
                        Rechercher un point relais
                      </button>
                    </div>
                  </div>
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-orange" role="status">
                      <span class="visually-hidden">Chargement...</span>
                    </div>
                    <p class="mt-3">Chargement...</p>
                  </div>
                  <div v-else-if="error" class="mt-3 alert alert-danger">
                    {{ error }}
                  </div>
                  <div v-else-if="pickupPoints.length === 0" class="mt-3">
                    Aucun point relais trouvé pour ce code postal
                  </div>
                  <div v-else class="row mt-4 pickup-points-container">
                    <div class="col-12">
                      <div class="liste-adresses">
                        <form class="w-100">
                          <label
                            v-for="point in pickupPoints"
                            :key="point.identifiant"
                            class="adress-box cursor-pointer w-100"
                            :class="{ selected: selectedPoint === point.identifiant }"
                          >
                            <input
                              type="radio"
                              :value="point.identifiant"
                              v-model="selectedPoint"
                              name="pointRelais"
                              class="radio-hidden"
                            />
                            <div class="adress-box-container d-flex flex-column flex-lg-row">
                              <div class="adress-box-left d-flex flex-column flex-md-row justify-content-between">
                                <div class="adress-box-info">
                                  <h4>{{ point.nom }}</h4>
                                  <p>
                                    {{ formatAddress(point) }}
                                    {{ point.codePostal }} {{ point.localite }}
                                  </p>
                                  <button
                                    class="btn btn-outline-orange"
                                    @click.prevent="selectPoint(point.identifiant)"
                                  >
                                    Je choisis ce point relais
                                  </button>
                                  <strong class="d-block" v-if="point.distanceEnMetre">
                                    à {{ (point.distanceEnMetre / 1000).toFixed(1) }} km
                                  </strong>
                                </div>
                                <div class="adress-box-time mt-3 mt-md-0">
                                  <h4>HORAIRES D'OUVERTURE</h4>
                                  <div v-for="day in getFormattedOpeningHours(point)" :key="day.jour">
                                    <p class="d-flex justify-content-between">
                                      <span>{{ day.jourNom }}</span>
                                      <span>: {{ day.horaires || "Fermé" }}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div class="adress-box-right mt-3 mt-lg-0">
                                <div class="map">
                                  <div
                                    v-if="googleMapsLoaded"
                                    class="map-container"
                                    :id="`map-${point.identifiant}`"
                                  ></div>
                                  <div v-else class="text-center p-4">Chargement de la carte...</div>
                                </div>
                              </div>
                            </div>
                          </label>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 py-3 block-recap">
                <label class="title-recap">Récapitulatif de la commande</label>

                <div v-if="showWarehouseNotice" class="alert alert-info my-3">
                  <i class="ti ti-info-circle"></i>
                  <p>
                    <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en cours, les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt logistique avant la fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger retard dans la prise en charge de vos commandes par ces derniers.
                  </p>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
                  <label class="recap-text p-0">Prix des produits</label>
                  <span class="recap-text">{{ TotalCart }} € HT</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="showRemiseLine && remise">
                  <p class="col-6 col-lg-6 p-0">
                    <label class="recap-text">Remise</label>
                    <br />
                    <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                    <span class="text-slogan" v-else>inclus dans le prix des produits</span>
                  </p>
                  <span class="recap-text">{{ remise }} €</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
                  <label class="recap-text p-0">TVA</label>
                  <span class="recap-text">{{ Tva }} €</span>
                </div>
               
                <div class="my-3 my-md-4 row">
                  <p class="col-12 col-lg-10">
                    <label class="recap-text">Livraison</label>
                    <br />
                    <span class="text-slogan">Frais calculés à l'étape suivante</span>
                  </p>
                </div>
                <hr class="divider" />
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
                  <label class="recap-text">Total TVA inclus</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn text-white btn-check-order mt-2 w-100 w-lg-60"
                      :disabled="!selectedPoint || loading"
                      @click="ConfirmCommande()"
                    >
                      <span
                        v-if="loading"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span>{{ loading ? "Confirmation en cours..." : "Confirmer" }}</span>
                    </button>
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies ssl et 3D Secure.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/cartStore";
import { useRegisterStore } from "@/stores/register";
import { getPickupPoints } from "@/api/shipping";
import { submitRelayPoint } from "@/api/orders";
import { useCheckoutStore } from "@/stores/useCheckoutStore";

export default {
  name: "LivraisonPointRelaisPage",
  data() {
    return {
      selectedPoint: null,
      pickupPoints: [],
      city: "",
      address: "",
      loading: false,
      error: null,
      cartStore: null,
      registerStore: null,
      googleMapsLoaded: false,
      googleMapsLoadingPromise: null,
      zipCode: "",
    };
  },

  computed: {
    TotalCart() {
      const cartStore = useCartStore();
      let total = 0;
      if (cartStore.Cart && cartStore.Cart.items?.length > 0) {
        total = cartStore.Cart.itemsSubtotal / 100;
      }
      return this.formatPrice(total);
    },
    Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal) )/ 100;
        return this.formatPrice(total);
      },

      remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },

       tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },
    cartsupp() {
      return useCartStore().Cart;
    },

     showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date('2026-01-07T00:00:00');
        return today < deadline;
      },
      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
  },

 async created() {
  this.registerStore = useRegisterStore();
  this.cartStore = useCartStore();
  this.checkoutStore = useCheckoutStore();

  // Determine which vet info to use
  let vetInfo = null;

  const cart = this.cartStore.Cart;
  const isLoggedInUserDelegate = this.registerStore.user?.role === "delegues";

  if (isLoggedInUserDelegate && cart?.vetCustomer) {
    vetInfo = cart.vetCustomer;
  } else {
    vetInfo = this.registerStore.VeterinaireData || {};
  }

  // Extract address details safely
  const billingAddress = vetInfo.adressesFacturation || {};

  this.zipCode = billingAddress.postcode || "";
  this.city = billingAddress.city || "";
  this.address = billingAddress.address1 || ""; // Optional: prefill street too

  // Load Google Maps
  this.googleMapsLoadingPromise = this.loadGoogleMaps();

  // If zip code is valid, auto-search pickup points
  if (this.zipCode.match(/^\d{5}$/)) {
    await this.searchPickupPoints();
  }
},

  watch: {
    pickupPoints: {
      handler(newPoints) {
        if (newPoints.length > 0 && this.googleMapsLoaded) {
          this.$nextTick(() => {
            this.initAllMaps();
          });
        }
      },
      deep: true,
      immediate: false,
    },
    googleMapsLoaded(newValue) {
      if (newValue && this.pickupPoints.length > 0) {
        this.$nextTick(() => {
          this.initAllMaps();
        });
      }
    },
  },
  methods: {
    formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value);
        return num.toFixed(2).replace('.', ',');
      },
    formatAddress(point) {
      return [point.adresse1, point.adresse2, point.adresse3].filter(Boolean).join(", ");
    },
    getFormattedOpeningHours(point) {
      const days = {
        1: "Lundi",
        2: "Mardi",
        3: "Mercredi",
        4: "Jeudi",
        5: "Vendredi",
        6: "Samedi",
        7: "Dimanche",
      };
      const horaires = point.listeHoraireOuverture.map(horaire => {
        let horairesStr = horaire.horairesAsString || "";
        if (Array.isArray(horaire.listeHoraireOuverture)) {
          horairesStr = horaire.listeHoraireOuverture.map(slot => `${slot.debut}-${slot.fin}`).join(" ");
        }
        return {
          jour: horaire.jour,
          jourNom: days[horaire.jour] || `Jour ${horaire.jour}`,
          horaires: horairesStr || null,
        };
      });
      return Object.keys(days)
        .map(jour => {
          const found = horaires.find(h => h.jour === parseInt(jour));
          return found || { jour: parseInt(jour), jourNom: days[jour], horaires: null };
        })
        .sort((a, b) => a.jour - b.jour);
    },
    async fetchPickupPoints(zipCode) {
      if (!zipCode.match(/^\d{5}$/)) {
        this.error = "Veuillez entrer un code postal valide (5 chiffres).";
        return;
      }

      if (!this.cartsupp?.tokenValue) {
        this.error = "Erreur : Aucun panier actif trouvé.";
        return;
      }

      this.loading = true;
      this.error = null;
      this.pickupPoints = [];
      this.selectedPoint = null;

      try {
        const response = await getPickupPoints(this.cartsupp.tokenValue,zipCode);
        if (response.data.success && response.data.data.listePointRelais) {
          this.pickupPoints = response.data.data.listePointRelais
            .filter(p => p.actif)
            .sort((a, b) => (a.distanceEnMetre || 0) - (b.distanceEnMetre || 0));
        } else {
          throw new Error( "Aucun point relais trouvé");
        }
      } catch (error) {
        console.error("Erreur:", error);
        this.error = error.message || "Erreur lors du chargement des points relais.";
      } finally {
        this.loading = false;
      }
    },
    async searchPickupPoints() {
      if (!this.zipCode && !this.city && !this.address) {
        this.error = "Veuillez entrer un code postal, une ville ou une adresse.";
        return;
      }

      if (this.zipCode && !/^\d{5}$/.test(this.zipCode.trim())) {
        this.error = "Code postal invalide. Veuillez entrer 5 chiffres.";
        return;
      }

      if (!this.cartsupp?.tokenValue) {
        this.error = "Erreur : Aucun panier actif trouvé.";
        return;
      }

      this.loading = true;
      this.error = null;
      this.pickupPoints = [];
      this.selectedPoint = null;

      try {
        const params = {};
        if (this.zipCode) params.zipCode = this.zipCode.trim();
        if (this.city) params.city = this.city.trim();
        if (this.address) params.address = this.address.trim();

        const response = await getPickupPoints(this.cartsupp.tokenValue,params);

        if (response.data.success && response.data.data.listePointRelais) {
          this.pickupPoints = response.data.data.listePointRelais
            .filter(p => p.actif)
            .sort((a, b) => (a.distanceEnMetre || 0) - (b.distanceEnMetre || 0));
        } else {
          throw new Error( "Aucun point relais trouvé");
        }
      } catch (error) {
        console.error("Erreur:", error);
        this.error = error.message || "Erreur lors de la recherche des points relais.";
      } finally {
        this.loading = false;
      }
    },
    selectPoint(id) {
      this.selectedPoint = id;
    },
    async ConfirmCommande() {
      if (this.loading) return;

      if (!this.selectedPoint) {
        this.error = "Veuillez sélectionner un point relais.";
        return;
      }

      this.loading = true;
      try {
        const selectedPoint = this.pickupPoints.find(p => p.identifiant === this.selectedPoint);
        if (!selectedPoint) throw new Error("Point relais introuvable");

        const order = this.cartsupp;
        const tokenValue = order.tokenValue;
        const relayId = selectedPoint.identifiant;

        await submitRelayPoint(tokenValue, relayId);

        this.$router.push({ name: "selection-adresse-relais" });
      } catch (error) {
        console.error("Erreur confirmation:", error);
        this.error = error.message || "Erreur lors de la confirmation.";
      } finally {
        this.loading = false;
      }
    },
    GoToStepCart() {
      this.$router.push({ name: "my-cart" });
    },

    GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
    BackToLivraison() {
      this.$router.push({ name: "livraison" });
    },
    async loadGoogleMaps() {
      if (this.googleMapsLoadingPromise) {
        return this.googleMapsLoadingPromise;
      }

      if (typeof window.google !== "undefined") {
        this.googleMapsLoaded = true;
        this.googleMapsLoadingPromise = Promise.resolve();
        return this.googleMapsLoadingPromise;
      }

      this.googleMapsLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          const checkGoogle = setInterval(() => {
            if (typeof window.google !== "undefined") {
              clearInterval(checkGoogle);
              this.googleMapsLoaded = true;
              resolve();
            }
          }, 50);
        };
        script.onerror = e => {
          console.error("Failed to load Google Maps script:", e);
          this.error = "Impossible de charger la carte. Veuillez réessayer plus tard.";
          this.googleMapsLoaded = false;
          reject(e);
        };
        document.head.appendChild(script);
      });
      return this.googleMapsLoadingPromise;
    },
    async initAllMaps() {
      if (!this.googleMapsLoaded && this.googleMapsLoadingPromise) {
        try {
          await this.googleMapsLoadingPromise;
        } catch (e) {
          console.error("Google Maps API failed to load, cannot initialize maps.", e);
          return;
        }
      } else if (!this.googleMapsLoaded) {
        console.warn("Attempted to initialize maps, but Google Maps API is not loaded or loading.");
        return;
      }

      this.pickupPoints.forEach(point => {
        const mapId = `map-${point.identifiant}`;
        const mapEl = document.getElementById(mapId);

        if (!mapEl) {
          console.warn(`Map element with ID ${mapId} not found. Skipping map initialization for this point.`);
          return;
        }

        const lat = parseFloat(point.coordGeolocalisationLatitude);
        const lng = parseFloat(point.coordGeolocalisationLongitude);

        if (isNaN(lat) || isNaN(lng)) {
          console.warn(
            `Invalid coordinates for point ${point.identifiant}: lat=${point.coordGeolocalisationLatitude}, lng=${point.coordGeolocalisationLongitude}`
          );
          return;
        }

        if (mapEl._g_maps_ || mapEl.querySelector(".gm-style")) {
          return;
        }

        try {
          const map = new google.maps.Map(mapEl, {
            center: { lat, lng },
            zoom: 15,
            disableDefaultUI: true,
            zoomControl: true,
            fullscreenControl: true,
          });

          new google.maps.Marker({
            position: { lat, lng },
            map,
          });
        } catch (e) {
          console.error(`Error initializing map for point ${point.identifiant}:`, e);
        }
      });
    },
  },
};
</script>

<style scoped>
.livraison-page {
  padding: 15px;
  text-align: center;
  background: #f5f6f9;
  min-height: 500px;
}

.section-header-breadcrumb {
  text-align: left;
  font-style: normal;
  padding: 0 15px;
}

.section-header-breadcrumb .title-page {
  font-size: 30px;
  font-weight: bold;
  color: #1e347d;
}

.section-header-breadcrumb .breadcrumb-text {
  font-size: 15px;
  font-weight: normal;
}

.section-header-breadcrumb .breadcrumb-text span {
  color: #1e347d;
}

.step-cart {
  justify-content: center;
  margin-bottom: 3rem;
}

.title-blue {
  color: #1e347d;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.step-cart-centent {
  justify-content: center;
  border: 1px solid #aeb1ba;
  border-radius: 10px;
}

.badge-blue {
  background-color: #1e347d !important;
  color: white !important;
  border-radius: 50%;
  font-size: 1.5rem;
}

.badge {
  background-color: #eee;
  color: #ec621a;
  border-radius: 50%;
  font-size: 1.5rem;
}

.step-cart .step-title {
  color: #000;
  font-weight: bold;
  font-size: 18px;
  opacity: 0.7;
}

.block-recap {
  background: white;
  text-align: left;
  padding: 30px;
  max-height: max-content;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
}

.block-recap .title-recap {
  color: #1e347d;
  font-size: 20px;
  font-weight: bold;
}

.block-recap .recap-text {
  font-size: 20px;
}

.block-recap .recap-text-blue {
  font-size: 20px;
  color: #1e347d;
  font-weight: bold;
}

.block-recap .text-slogan {
  font-size: 12px;
  color: #1e347d;
  font-style: italic;
}

.block-recap .divider {
  width: 90%;
  position: relative;
  left: 5%;
}

.alert {
  font-size: 1rem;
}

.alert-danger {
  color: red;
}


.spinner-border.text-orange {
  border-color: #ec621a;
  border-right-color: transparent;
}

.adress-box {
  display: flex;
  flex-direction: column;
  border: 2px solid #aeb1ba;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.adress-box.selected {
  background: #f5f6f9;
  border: 2px solid #1e347d;
}

.adress-box-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.adress-box-left {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.adress-box-right {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.adress-box-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.adress-box-info h4 {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.adress-box-info p {
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}

.btn-outline-orange {
  border: 1px solid #ec621a;
  color: #ec621a;
  font-size: 12px !important;
  padding: 0.5rem 1rem;
}

.adress-box-time {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 65%;
  padding-right: 30px;
}

.adress-box-time h4 {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.adress-box-time p {
  font-size: 0.875rem;
}

.search-block form {
  position: relative;
}

.search-block input {
  padding-right: 2.5rem;
}

.search-btn {
  position: absolute;
  right: 0.625rem;
  top: 50% !important;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #1e347d;
}

.radio-hidden {
  display: none;
}

.map-container {
  width: 100%;
  max-width: 300px;
  height: 200px;
  border-radius: 10px;
  position: relative;
  z-index: 10;
  pointer-events: auto;
}

.map {
  position: relative;
  z-index: 10;
  pointer-events: auto;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
}

.adress-box {
  position: relative;
  z-index: 1;
}

.liste-adresses {
  pointer-events: auto;
}

.pickup-points-container {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.block-adresses {
  overflow: hidden;
}

/* Responsive Styles pour mobiles uniquement - Même approche que les autres composants */
@media (max-width: 768px) {
  /* Cacher step-cart-centent exactement comme dans les autres composants */
  .step-cart-centent {
    display: none !important;
  }

  .livraison-page {
    padding: 10px;
  }

  .section-header-breadcrumb {
    padding: 0 10px;
    text-align: center;
  }

  .section-header-breadcrumb .title-page {
    font-size: 24px;
    text-align: center;
  }

  .section-header-breadcrumb .breadcrumb-text {
    font-size: 14px;
    text-align: center;
  }

  .content.cart-page-inner {
    gap: 20px !important;
  }

  .block-adresses {
    margin-bottom: 1rem;
  }

  .step-cart {
    margin-bottom: 1.5rem;
  }

  .title-blue {
    font-size: 16px;
  }

  .bg-white.round-10 {
    padding: 15px !important;
  }

  .search-group {
    flex-direction: column;
  }

  .form-input {
    width: 100%;
  }

  .btn-orange {
    width: 100%;
  }

  .map-container {
    height: 150px;
    max-width: 100%;
  }

  .adress-box-info h4,
  .adress-box-time h4 {
    font-size: 14px;
  }

  .adress-box-info p,
  .adress-box-time p {
    font-size: 13px;
  }

  .btn-outline-orange {
    font-size: 12px !important;
    width: 100%;
  }

  .block-recap {
    padding: 20px;
  }

  .block-recap .title-recap {
    font-size: 18px;
    text-align: center;
    display: block;
    width: 100%;
  }

  .block-recap .recap-text,
  .block-recap .recap-text-blue {
    font-size: 16px;
  }

  .btn-check-order {
    width: 100%;
    padding: 12px;
  }

  .back-link {
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  .separator {
    display: none;
  }

  .adress-box-time {
    width: 100%;
    padding-right: 0;
    margin-top: 15px;
  }

  .adress-box-left {
    flex-direction: column;
  }

  .pickup-points-container {
    max-height: 400px;
  }
}

@media (max-width: 576px) {
  .section-header-breadcrumb .title-page {
    font-size: 20px;
  }

  .breadcrumb-text {
    font-size: 13px !important;
  }

  .title-blue {
    font-size: 15px;
  }

  .adress-box {
    padding: 10px;
  }

  .block-recap {
    padding: 15px;
  }

  .block-recap .recap-text,
  .block-recap .recap-text-blue {
    font-size: 15px;
  }

  .adress-box-info h4,
  .adress-box-time h4 {
    font-size: 13px;
  }

  .adress-box-info p,
  .adress-box-time p {
    font-size: 12px;
  }

  .map-container {
    height: 120px;
  }
}

/* Pour les très petits écrans */
@media (max-width: 360px) {
  .section-header-breadcrumb .title-page {
    font-size: 18px;
  }

  .breadcrumb-text {
    font-size: 12px !important;
  }

  .adress-box {
    padding: 8px;
  }

  .block-recap {
    padding: 12px;
  }

  .map-container {
    height: 100px;
  }
}

/* Desktop layout */
@media (min-width: 992px) {
  .adress-box-container {
    flex-direction: row;
    gap: 1.5rem;
  }

  .adress-box-left {
    flex-direction: row;
    gap: 1.5rem;
    flex: 2;
  }

  .adress-box-right {
    flex: 1;
    justify-content: center;
  }

  .map-container {
    max-width: 100%;
    height: 200px;
  }
}
</style>